import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDStack, FDDisplayText, FDHeadlineText, FDBodyText,
} from '@facet-wealth/design';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import classNames from 'classnames';
import {
  FacLoadingLottie,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FacLoadingLottie';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = makeStyles((theme) => ({
  height: {
    height: '100dvh',
    overflow: 'auto',
  },
  mobileHeight: {
    height: `calc(100dvh - ${theme.heights.mobileBottomNavigationHeight}px)`,
  },
  newNavHeight: {
    height: `calc(100dvh - ${theme.heights.desktopTopNavigationHeight}px)`,
  },
}));


export const ExecuteSelectLoadingPage = ({ resource }) => {
  const isMobile = useMobileLayout();
  const theme = useTheme();
  const classes = useStyles(theme);
  const newNavPresent = true;

  return (
    <Box
      className={classNames(classes.height, {
        [classes.mobileHeight]: isMobile,
        [classes.newNavHeight]: !isMobile && newNavPresent,
      })}
      {...DataValueMap.init('execute-select-loading-page').build()}
    >
      <FDStack
        alignItems={'center'}
        justifyContent={'center'}
        height={'100%'}
      >
        <LottieLoadingLayout>
          <FadeInBox>
            <FDStack
              direction={'column'}
              spacing={2}
              alignItems={'center'}
              paddingX={1}
              justifyContent={'center'}
            >
              <FDDisplayText value={resource.attr('loadingTitle')} color={'textSecondary'} align={'center'} />
              <FDHeadlineText value={resource.attr('loadingSubtitle')} color={'textPrimary'} size={'lg'} align={'center'} />
              {resource.withRelationship(fr.relationships.loadingLottie.name,
                (rel) => (<FacLoadingLottie rel={rel} />),
                () => null)}
              <FDBodyText value={resource.attr('loadingDescription')} color={'textPrimary'} size={'lg'} align={'center'} />
            </FDStack>
          </FadeInBox>
        </LottieLoadingLayout>
      </FDStack>
    </Box>
  );
};

ExecuteSelectLoadingPage.defaultProps = {
};

ExecuteSelectLoadingPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
